import { render, staticRenderFns } from "./ShipmentTracking.vue?vue&type=template&id=468f3fee"
import script from "./ShipmentTracking.vue?vue&type=script&lang=js"
export * from "./ShipmentTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports